import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { adminColors, adminTypography } from '../../../../styles/adminDesignTokens';
import { adminButtonSx, adminButtonToneSx, adminCombineSx } from '../../../../styles/adminComponentStyles';

type AgentConfigurationSaveSectionProps = {
  onSave: () => void;
  saving: boolean;
  disabled: boolean;
};

const AgentConfigurationSaveSection: React.FC<AgentConfigurationSaveSectionProps> = ({ onSave, saving, disabled }) => {
  return (
    <Box sx={{ textAlign: 'right' }}>
      <Button
        variant="contained"
        onClick={onSave}
        disabled={disabled}
        size="small"
        sx={adminCombineSx(adminButtonSx, adminButtonToneSx.primary, { minWidth: 120 })}
      >
        {saving ? <CircularProgress size={20} /> : 'Save'}
      </Button>
      <Typography sx={{ ...adminTypography.helper, color: adminColors.mutedText, display: 'block', mt: 0.5 }}>
        It may take a few minutes.
      </Typography>
    </Box>
  );
};

export default React.memo(AgentConfigurationSaveSection);
